module.exports = __webpack_public_path__ + "img/icn_less.fc57be41.svg";